import { AppThunkAction } from '../../index'
import { VIEWPORT_STATE_ACTION_TYPES } from '../../../types/viewport'

export const setViewportWidth = (width: number): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: VIEWPORT_STATE_ACTION_TYPES.SET_VIEWPORT_WIDTH,
			payload: width,
		})
	}
}
